import { Component, OnInit, Input } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { InvestorService } from '../investor.service';
import { Appconstants } from '../../../shared/app-constants';
import { CommonModule } from '@angular/common';
//import { MsalService} from '@azure/msal-angular'; 
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import { environment } from '../../../../environments/environment.prod';

@Component({
    selector: 'app-downloadfile',
    templateUrl: './downloadfile.component.html',
    styleUrls: ['./downloadfile.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class DownloadfileComponent implements OnInit {
  saveDPInput: object = {
    dp_version: ""}
  ;
  dpData:object;
  blnError:boolean=false;
  strErrorMessage:string="";
  blnSaveDisable:boolean=true;
  pageLoad:boolean=false;
  allDocs:any;
  strResponse:object={};
  confirmationPopup:boolean=false;
  global_msg:string="";
  blnDeleteLoading:boolean=false;
  @Input() docType:string="";
  @Input() cycleFlag:boolean;
  @Input() selYear:string="";
  @Input() cycleName:string=""; 
  @Input() windowFlag:boolean;

  ///constructor(private router:Router, private investorService: InvestorService,private telemetryService:TelemetryService) { }
  constructor(private router:Router, private investorService: InvestorService) { }

  ngOnInit() {
    console.log("docType",this.docType)
    // this.fnGetAllDocByType(this.docType,this.selYear,this.cycleName);
  }

  ngOnChanges(){
      this.pageLoad = false;
      this.fnGetAllDocByType(this.docType,this.selYear,this.cycleName);
    }
  fnGetAllDocByType(docType,selYear,cycleName)
  {
    this.pageLoad = false;
    this.allDocs=[];
    this.investorService.getAllDocByType(docType,selYear,cycleName).subscribe(data => {
      this.allDocs= data['doc_list'] as object;
      this.global_msg=data['global_message'];
      console.log("output",  this.allDocs);
      if (this.allDocs.length != undefined && this.allDocs.length > 0) 
      { 
        this.pageLoad = true; 
      }
      else {
        this.pageLoad = false;
      }
      
    },err=>{
      console.log(err);
      this.pageLoad = false;      
    });    
  }

  // fnGetAllDocByTypeAfterDeletion(docType)
  // {
  //   this.pageLoad = false;
  //   this.allDocs=[];
  //   this.investorService.getAllDocByTypeAfterDeletion(docType).subscribe(data => {
  //     this.allDocs= data as object;
  //     console.log("output",  this.allDocs);
  //     if (this.allDocs.length != undefined && this.allDocs.length > 0) 
  //     { 
  //       this.pageLoad = true; 
  //     }
  //     else {
  //       this.pageLoad = false;
  //     }
      
  //   },err=>{
  //     console.log(err);
  //     this.pageLoad = false;      
  //   });    
  // }

  fnDownloadDoc(docName)
  {
    console.log("docType",this.docType)
    //let docAzureName=docName.split(':')[1];
    let docAzureName= docName;
    console.log("docAzureName",docAzureName)
    this.investorService.downloadFile(docAzureName).subscribe(data => {    
      console.log("output",  data);
      this.base64ToFile(data['documentContent'],data['documentName']);  
          if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: "DownloadDoc"+ " " + Appconstants.success,
              pageid: Appconstants.documentDownload
            }
           // this.telemetryService.interact(telemetryEventData);
          }
      
    },err=>{
      console.log(err);    
      if(environment.telemetryFlg){
        let telemetryEventData = {
          type: INTERACTEVENTS.CLICK,
          id: "DownloadDoc"+ " " + Appconstants.failure+ err,
          pageid: Appconstants.documentDownload
        }
       // this.telemetryService.interact(telemetryEventData);
      } 
    });    
  }

private base64ToFile(base64Data,docName) {
  console.log(base64Data,docName);
    let byteArray: Uint8Array;
    let blob: Blob;
    let filename: string;
    let byteCharacters = atob(base64Data);
    let byteNumbers = new Array(byteCharacters.length);
    let link: HTMLAnchorElement;
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    byteArray = new Uint8Array(byteNumbers);
    blob = new Blob([byteArray as any]);

    console.log(blob);
    if ((navigator as any).msSaveBlob) {
      filename = docName;
      (navigator as any).msSaveBlob(blob, filename);
    } else {
      link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute('visibility', 'hidden');
      link.download = docName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }


  
  fnDeleteDocument(docName)
  {
  console.log("fnDeleteDocument",docName);
  let docAzureName=docName['documentAzureName'];
  this.blnDeleteLoading=true;
  this.investorService.deleteFileFromAzure(docAzureName).subscribe(data => {    
    console.log("output",  data);
    this.strResponse= data as object;
    this.blnDeleteLoading=false;
        if (this.strResponse['code'] == "1") {
        
          //this.fnGetAllDocByTypeAfterDeletion(this.docType);
          //this.router.navigate(['']);
        this.confirmationPopup=true;
          if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: "DeleteDoc"+ " " + Appconstants.success,
              pageid: Appconstants.deleteDoc
            }
         //   this.telemetryService.interact(telemetryEventData);
          } 
        }
        else{
          this.blnError=true;
          this.strErrorMessage=this.strResponse['message'];
          if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: "DeleteDoc"+ " " + Appconstants.error+ this.strErrorMessage,
              pageid: Appconstants.deleteDoc
            }
         //   this.telemetryService.interact(telemetryEventData);
          } 
          setTimeout(() => {
              this.strErrorMessage = "";
              this.blnError=false;
            }, 4000);
        }
      },err=>{
        console.log(err); 
        this.blnError=true;    
        this.strErrorMessage="Some error occurred.Please try again!"
        this.blnDeleteLoading=false;
        if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: "DeleteDoc"+ " " + Appconstants.failure+ err,
            pageid: Appconstants.deleteDoc
          }
        //  this.telemetryService.interact(telemetryEventData);
        } 
        setTimeout(() => {
          this.strErrorMessage = "";
          this.blnError=false;
      }, 4000);
    });   
  }


  closeModalPopup(){
    this.confirmationPopup=false;
    this.fnGetAllDocByType(this.docType,this.selYear,this.cycleName);
  }

}
